import { makeStyles, Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

import * as Colors from 'utils/color-styles';

export const WIDGET_BORDER_RADIUS = 2; // Use theme.spacing(2) for consistency

export const useSharedWidgetStyles = makeStyles((theme: Theme) =>
  createStyles({
    widgetContainer: {
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      position: 'relative',
      bottom: 0,
      background: theme.palette.background.paper,
      paddingTop: theme.spacing(2),
    },

    rightJustifiedWidgetContainer: {
      marginTop: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: theme.spacing(1),
      position: 'relative',
      bottom: 0,
      background: theme.palette.background.paper,
      paddingTop: theme.spacing(2),
      width: '100%',
    },

    inputFieldContainer: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(1, 2),
      paddingRight: theme.spacing(7),
      backgroundColor: '#F4F4F6',
      border: '2px solid transparent',
      position: 'relative',
      lineHeight: 1.6,
      fontSize: theme.typography.body1.fontSize,
      // User interaction widgets: sharper edge on the right
      borderRadius: `${theme.spacing(WIDGET_BORDER_RADIUS)}px ${theme.spacing(
        WIDGET_BORDER_RADIUS
      )}px 0 ${theme.spacing(WIDGET_BORDER_RADIUS)}px`,
    },

    sendButton: {
      position: 'absolute',
      right: theme.spacing(1),
      width: 40,
      height: 40,
      minWidth: 0,
      borderRadius: '50%',
      transform: 'rotate(-30deg)',
      padding: 0,
      backgroundColor: Colors.purple,
      color: theme.palette.common.white,
      zIndex: 10,
      '&:hover': {
        backgroundColor: Colors.darkPurple,
      },
      '&.Mui-disabled': {
        backgroundColor: Colors.gray5,
        color: Colors.gray3,
      },
    },

    sendIcon: {
      color: theme.palette.common.white,
      fontSize: theme.typography.pxToRem(20),
    },

    backButton: {
      position: 'absolute',
      top: 0,
      left: 0,
      padding: theme.spacing(0.5),
      color: theme.palette.text.secondary,
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
      },
    },

    backButtonIcon: {
      fontSize: theme.typography.pxToRem(20),
    },
  })
);
